import { createAction, props } from '@ngrx/store';
import { VehicleTypeApiModel } from 'app/models/vehicle-types-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

export const loadVehicleTypes = createAction('[Vehicles types] Load');

export const loadVehicleTypesSuccess = createAction(
  '[Vehicles types] Load Successful',
  props<{ response: MwPayloadModel<VehicleTypeApiModel[]> }>()
);

export const loadVehicleTypesFailed = createAction(
  '[Vehicle types] Load Failed',
  props<{ error: any }>()
);

export const createVehicleType = createAction(
  '[Vehicles types] Create',
  props<{ vehicleType: VehicleTypeApiModel }>()
);

export const createVehicleTypeSuccess = createAction(
  '[Vehicles types] Create Successful'
);

export const createVehicleTypeFailed = createAction(
  '[Vehicle types] Create Failed',
  props<{ error: any }>()
);

export const updateVehicleType = createAction(
  '[Vehicles types] Update',
  props<{ vehicleType: VehicleTypeApiModel }>()
);

export const updateVehicleTypeSuccess = createAction(
  '[Vehicles types] Update Successful'
);

export const updateVehicleTypeFailed = createAction(
  '[Vehicle types] Update Failed',
  props<{ error: any }>()
);

export const deleteVehicleType = createAction(
  '[Vehicles types] Delete',
  props<{ vehicleType: VehicleTypeApiModel }>()
);

export const deleteVehicleTypeSuccess = createAction(
  '[Vehicles types] Delete Successful'
);

export const deleteVehicleTypeFailed = createAction(
  '[Vehicle types] Delete Failed',
  props<{ error: any }>()
);

export const deleteVehicleTypesList = createAction(
  '[Vehicles types] Delete List',
  props<{ vehicleTypes: VehicleTypeApiModel[] }>()
);

export const deleteVehicleTypesListSuccess = createAction(
  '[Vehicles types] Delete List Successful'
);

export const deleteVehicleTypesListFailed = createAction(
  '[Vehicle types] Delete List Failed',
  props<{ error: any }>()
);

export const resetVehicleTypes = createAction('[Vehicle types] Reset');
